/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createMachine } from 'xstate';

import { OrganizationTypeSelection } from './OrganizationTypeSelection';
import { Chapter } from './Chapter';
import { Nonprofit } from './Nonprofit';
import { School } from './School';
import { Membership } from './Membership';
import { NonUS } from './NonUS';
import { Rest } from './Rest';
import { Gov } from './Gov';

export type NonprofitOnboardingMachineEvents =
  | { type: 'PREV' }
  | { type: 'OPTION_CHAPTER' }
  | { type: 'OPTION_501C3' }
  | { type: 'OPTION_GOV' }
  | { type: 'OPTION_SCHOOL' }
  | { type: 'OPTION_MEMBERSHIP' }
  | { type: 'OPTION_NON_US' }
  | { type: 'OPTION_REST' }
  | { type: 'CREATE_GOV' };

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NonprofitOnboardingMachineContext {}

export const organizationNotFoundMachine = (initial = 'organizationTypeSelection') =>
  createMachine({
    /** @xstate-layout N4IgpgJg5mDOIC5QHsBOUCGA7AlgLwwBcdksA5ZQgMWQFcsIA6NTXA40gFQE8AHMAMpgANmADGHLAGIACgCUAogDUA2gAYAuolC9ksHJO0gAHogCMZgOyMAbDYAsay-csBOS5YAcnmwGYANCDciDZmnoxqvpFhrq42zp4ArAC+yYEs2PhEJOSUNPRMGWzZXHyCIuKSUgDyMpwAktVkAPoAwgASAIJ1CnLqWkgguvqGg6YI9maujJ72vpaJPgBMzmH2gcEIlr7hantqrmueUzYpaSBFWZIU1HQMzOiZ7Dk8-EKiEjk1dY0tiWpmVq+fpGYYGHJGcaTaazeaLGwrSazDaIOb2RixWLbRJeNQuWapdKPYrXPJ3QrEq4vMrvSpfWoNJrNADi1VUmlBenBpEhqKmMzmC2Wq2RQUQiV8iQxmNmLnmTjMhIulOepBu+Xul1VWFe5Q+VQZv2aAg61WqABkQYMwaNQFD+bChQiResxQgzL4lhF9r4zEslt5QpYlVqSrlbgUHqwqaU3hVPqRvoyWgBZBQpgBCvQE7XqMitOi5tpMfJhgvhiLWKIQS090tinmi9nsEqcIZVYfV5KjTzDutpCekhqZZCZAFUBAWhkWIWNSwK4cKka7Nn5rPtIscbAdEmF29HtV3I6HJP34wafkzFAJOFObbO7fPHRWXdXfO-6+4bK57Aj-r-917UkI3uMQAAsMF4QgwFQWRFHZAZCxGB8SwQRIW0YZwlimZspksNRjmrGxPGsf49lOPYW1WQCSRyI97n+MwxF8ODlDvGceTnNCMKwnDoXwwi3R2dF7ExU4FiWVwnB-GiY3DDUmCgZAADdWIQzlkM4x9uKlLDayWFs7EsSTq3sJJGFEhszEcX0SM8WTDzJSMlNU1pFE6TgFBZNl2M0rBeS2VwvTiA4llbNRvx8asJXCSyG22BZvwczsnPuWBwOQZBhDU3zuX8rj0N0+xsJ-fiCLMatjkYMjKJ2RJa1K5LgIUxgAFswFagAjGDYDAnBeByjlrQ4-LtMKzDir4vDyurMIvTi44G0SdDJSaujUqYLBSAnQbEOnPyAvG3jSumwTNnhar9gsX1tkks4iQPFKQKYVA4EIXaNLyw6eMmk73Bmt0A18CyZWOXxXESVxfDWtUNsYMRXqIMBmRUj7hoOrikjMGY8XQ27JVlUySM-KTDgMyTUnOLaIDgIwT3W57PuLcYAFoKrdFmbG9Dcef2YNznp2Hnp7WjYz1OktP2r6uJcatLH5MzfGbAEFjMYj7IFjtmu7cDIOg1AmZQ8YHHCD0A1EyLPCiAI3VujE1Y8KHXE8KSlhsGH5O7RjmMNyXjbMxgzdmOJnatyJTMk+27F3UIIb9K2PfoxSVN90bUPiLnJOIhFwaSYylmiqIo9OKGW2K0TE7h9KwMy4RU4Ck3A89YPLet2a3eL5bhIRU5K+F9qup6vreHrrjG6Di3Q7bwGVk7pYAQcWtvD7lqtqwCdR+08fm8n7xp9XX0o-wyIJWIj0V+7V7YEITf04DieQ738OhIDYuy68FxiovyMEbAJGUeUrfcYEN0RTF3FbRYxUDI23Oh+SYdhfx2AcL4eIlNkhAA */
    id: 'organizationNotFound',
    key: 'organizationNotFound',
    initial,
    schema: {
      context: {} as NonprofitOnboardingMachineContext,
      events: {} as NonprofitOnboardingMachineEvents,
      services: {} as Record<string, never>,
    },
    states: {
      organizationTypeSelection: {
        on: {
          PREV: { target: 'organizationTypeSelection', actions: ['close'] },
          OPTION_CHAPTER: { target: 'chapter' },
          OPTION_501C3: { target: '501c3' },
          OPTION_GOV: { target: 'gov' },
          OPTION_SCHOOL: { target: 'school' },
          OPTION_MEMBERSHIP: { target: 'membership' },
          OPTION_NON_US: { target: 'nonUS' },
          OPTION_REST: { target: 'rest' },
        },
        meta: {
          component: OrganizationTypeSelection,
        },
      },
      chapter: {
        on: {
          PREV: { target: 'organizationTypeSelection', actions: ['persistUrl'] },
        },
        meta: {
          component: Chapter,
        },
      },
      '501c3': {
        on: {
          PREV: { target: 'organizationTypeSelection' },
        },
        meta: {
          component: Nonprofit,
        },
      },
      gov: {
        on: {
          PREV: { target: 'organizationTypeSelection' },
          CREATE_GOV: { actions: ['createGov'] },
        },
        meta: {
          component: Gov,
        },
      },
      school: {
        on: {
          PREV: { target: 'organizationTypeSelection' },
        },
        meta: {
          component: School,
        },
      },
      membership: {
        on: {
          PREV: { target: 'organizationTypeSelection' },
        },
        meta: {
          component: Membership,
        },
      },
      nonUS: {
        on: {
          PREV: { target: 'organizationTypeSelection' },
        },
        meta: {
          component: NonUS,
        },
      },
      rest: {
        on: {
          PREV: { target: 'organizationTypeSelection' },
        },
        meta: {
          component: Rest,
        },
      },
    },
    tsTypes: {} as import('./machine.typegen').Typegen0,
  });
